import { observable, action, reaction, makeObservable } from 'mobx'

import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'
import { MIN_WIDTH } from '@client/components/Block/constants'

export default class VideoModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    makeObservable(this)

    this.editor = editor

    this.settings.set({ ...defaultSettings, ...data.settings })

    reaction(
      () => this.containerDimensions.width,
      (containerWidth) => {
        if (this.editor?.viewMode === 'mobile') return

        const shouldMaxWidth =
          !this.settings.values.width ||
          +this.settings.values.width > containerWidth ||
          this.settings.values.fullWidth

        if (shouldMaxWidth && containerWidth >= MIN_WIDTH) {
          this.settings.set({
            width: containerWidth.toString(),
          })
        }
      }
    )
  }

  @observable containerDimensions = { width: 0, height: 0 }

  @action setContainerDimensions = (obj) => {
    if (!obj || (obj && !obj.width) || (obj && obj.width < MIN_WIDTH)) {
      return
    }
    this.containerDimensions = obj
  }
}

export const NULL = new VideoModel()
